import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import AboutSection from "@/components/AboutSection";
import MissionSection from "@/components/MissionSection";
import BenefitsSection from "@/components/BenefitsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MapPin, Users, ArrowRight } from "lucide-react";
import { useMemberCount } from "@/hooks/useMemberCount";

const Index = () => {
  const { data: counts } = useMemberCount();
  
  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <AboutSection />
      
      {/* Chapter Selection Section */}
      <section className="py-20 bg-secondary/30">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4 animate-fade-in">
              Find Your Local Chapter
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto animate-fade-in" style={{ animationDelay: "0.1s" }}>
              We have multiple chapters across Missouri, each with its own vibrant community of business professionals. Find the chapter nearest to you and start connecting today.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <Card className="hover:shadow-xl transition-all hover:-translate-y-1 animate-fade-in flex flex-col" style={{ animationDelay: "0.2s" }}>
              <CardContent className="p-8 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-4">
                  <div className="bg-primary/10 p-3 rounded-full">
                    <MapPin className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold">Washington, MO</h3>
                    <p className="text-muted-foreground">Our Founding Chapter</p>
                  </div>
                </div>
                <p className="text-muted-foreground mb-6">
                  Join our original chapter serving the Washington, Missouri area. Bi-weekly meetings on the 2nd &amp; 4th Wednesday of each month at the Swallows Nest.
                </p>
                <div className="flex items-center gap-2 text-sm text-muted-foreground mb-6">
                  <Users className="w-4 h-4" />
                  <span>{counts?.washington ?? "—"} Active Members</span>
                </div>
                <div className="mt-auto">
                  <Button asChild className="w-full group">
                    <a href="/washington">
                      Explore Washington Chapter
                      <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                    </a>
                  </Button>
                </div>
              </CardContent>
            </Card>

            <Card className="hover:shadow-xl transition-all hover:-translate-y-1 animate-fade-in flex flex-col" style={{ animationDelay: "0.3s" }}>
              <CardContent className="p-8 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-4">
                  <div className="bg-primary/10 p-3 rounded-full">
                    <MapPin className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold">Union, MO</h3>
                    <p className="text-muted-foreground">New Chapter</p>
                  </div>
                </div>
                <p className="text-muted-foreground mb-6">
                  Our newest chapter expanding RCN's reach to the Union, Missouri community. Weekly meetings every Thursday at the Scenic Regional Library - Union Branch.
                </p>
                <div className="flex items-center gap-2 text-sm text-muted-foreground mb-6">
                  <Users className="w-4 h-4" />
                  <span>{counts?.union ?? "—"} Active Members</span>
                </div>
                <div className="mt-auto">
                  <Button asChild className="w-full group">
                    <a href="/union">
                      Explore Union Chapter
                      <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                    </a>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <MissionSection />
      <BenefitsSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Index;